<template>
  <div class="three-box">
    <div class="three-one-box">
      <div class="three-top">
        <div class="three-top-left">
          <h1>新闻中心</h1>
          <span>PRESS CENTER</span>
        </div>
        <div class="three-top-right" @click="goUrl()">
          <img src="../../../images/mores.png" alt />
          <a href="javascript:;">查看更多</a>
        </div>
      </div>
      <div class="three-one-bottom">
        <dl v-for="(item,index) in list" :key="index"
            :class="index === currentIndex ? 'active' : ''"
            @click="goxq(item.id)"
            @mouseenter="mouseOver(index)"
            @mouseleave="mouseLeave(index)"
        >
          <dt>
            <img :src="item.image" alt />
          </dt>
          <dd>
            <div class="div">
              <h3>{{ item.title }}</h3>
              <a href="javascript:;"
                >{{item.subtitle}}</a
              >
              <div class="bottom">
                <a href="javascript:;">查看详情</a>
                <img class="you" src="../../../images/right.png" alt />
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: "",
      list: []
    };
  },
  methods: {
    mouseOver(index) {
      this.currentIndex = index;
    },
    mouseLeave(index) {
      this.currentIndex = "";
    },
    goxq(id){
      this.$router.push({path:'/workIn',query:{id}})
    },
    goUrl(){
      this.$router.push('/workIn')
    }
  },
  created() {
     this.$api.homepage.news().then(res=>{
        this.list=res.data
    })
  }
};
</script>

<style lang="less" scoped>
.three-box {
  width: 1250px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  .three-one-box {
    flex: 1.6;
    display: flex;
    flex-direction: column;
    margin-top: 82px;
    .three-one-bottom {
      flex: 3;
      display: flex;
      margin: 45px 0px;
      .active {
        border: 1px solid #f7b500;
      }
      dl {
        width: 400px;
        height: 428px;
        cursor: pointer;
        border: 1px solid #f8f8f8;
        position: relative;
        margin-right: 24px;
        dt {
          width: 400px;
          height: 230px;
          img {
            width: 400px;
            height: 230px;
          }
        }
        dd {
          width: 400px;
          height: 176px;
          margin: auto;
          .div {
            width: 380px;
            height: 198px;
            margin: auto;
            h3 {
              height: 40px;
              width: 100%;
              font-size: 18px;
              text-align: left;
              color: #333333;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            a {
              height: 40px;
              font-size: 16px;
              text-align: left;
              color: #999;
              line-height: 20px;
            }
            .bottom {
              position: absolute;
              left: 0px;
              bottom: 0px;
              width: 100%;
              height: 50px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 10px;
              .you {
                position: absolute;
                right: 30px;
                top: 9px;
              }
            }
          }
        }
      }
    }
  }
}
.three-top {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .three-top-left {
    h1 {
      font-size: 28px;
      font-weight: 700;
      text-align: left;
      color: #333333;
      line-height: 24px;
    }
    span{
      font-size: 20px;
      text-align: left;
      color: #b8b8b8;
      line-height: 41px;
    }
  }
  .three-top-right {
    a {
      font-size: 16px;
      color: #999999;
      line-height: 19px;
      margin-left: 5px;
    }
  }
}
</style> 